import React, {Component} from 'react';
import {Col, Form, message, Modal, Row, Select} from 'antd';

import {queryAccountList} from '@api/core/user';
import SelectOrg from '../../comm/SelectOrg';

const FormItem = Form.Item;
const { Option } = Select;

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      accountList: [],
      orgUuid: '',
    };
  }

  componentDidMount() {
    this.loadAccount();
  }

  submit = () => {
    const data = this.props.form.getFieldsValue();
    data.orgUuid = this.state.orgUuid;
    this.props.form.validateFields(err => {
      if (!err) {
        this.props.handSubmit(data);
      }
    });
  };

  onChangeOrg = value => {
    this.setState({
      orgUuid: value,
    });
    this.loadAccount(value);
    this.props.form.setFieldsValue({ userUuid: '' });
  };

  /**
   *获取用户列表
   */
  loadAccount = orgUuid => {
    const uuid = orgUuid || '';
    queryAccountList({ orgUuid: uuid }).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          accountList: res.data,
        });
      } else {
        message.error(res.message);
      }
    });
  };

  render() {
    const { cancel } = this.props;
    const { accountList } = this.state;
    const { getFieldDecorator } = this.props.form;
    const formItemLayout = {
      labelCol: { span: 8 },
      wrapperCol: { span: 16 },
    };
    const formItemLayout2 = {
      labelCol: { span: 12 },
      wrapperCol: { span: 11 },
    };
    const formItemLayout3 = {
      labelCol: { span: 1 },
      wrapperCol: { span: 22 },
    };
    return (
      <Modal
        title="分配合同"
        width={400}
        visible
        onCancel={cancel}
        onOk={this.submit}
        maskClosable={false}
      >
        <Form className="modal" layout="inline">
          <Row>
            <Col span={15}>
              <FormItem {...formItemLayout2} label="分配人" style={{ width: '100%' }}>
                {getFieldDecorator('orgUuid', {
                  rules: [{ required: true, message: '部门不能为空！' }],
                })(<SelectOrg onChange={this.onChangeOrg} orgUuid={this.state.orgUuid} />)}
              </FormItem>
            </Col>
            <Col span={7}>
              <FormItem {...formItemLayout3} style={{ width: '100%' }}>
                {getFieldDecorator('userUuid', {
                  rules: [{ required: true, message: '姓名不能为空！' }],
                })(
                  <Select placeholder="姓名">
                    {accountList.map(item => {
                      return <Option key={item.uuid}>{item.name}</Option>;
                    })}
                  </Select>,
                )}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <FormItem {...formItemLayout} label="分配原因">
              {getFieldDecorator('remark', {
                ules: [{ required: true, message: '分配原因不能为空！' }],
              })(
                <Select>
                  <Option value="初次领用分配合同">初次领用分配合同</Option>
                  <Option value="经理带领调配合同">经理带领调配合同</Option>
                  <Option value="领用和通过多给他人">领用和通过多给他人</Option>
                  <Option value="员工离职重新调配">员工离职重新调配</Option>
                  <Option value="其它原因">其它原因</Option>
                </Select>,
              )}
            </FormItem>
          </Row>
        </Form>
      </Modal>
    );
  }
}
export default Form.create()(Index);



// WEBPACK FOOTER //
// ./src/components/xianxing/contract/ModalAllot.js